import api from './api';

// Shared, in-flight-deduplicated fetch of the connected ad accounts.
// Several components mount together on a page (header AccountSwitcher + the
// campaign list + modals) and each used to fire its own
// GET /accounts/google/accounts/ - two+ identical requests on every load.
// This returns the SAME promise to concurrent callers, then clears once it
// settles so a later navigation re-fetches fresh (no stale cache to invalidate).
let inflight = null;

export function getGoogleAccounts() {
  if (inflight) return inflight;
  inflight = api.get('/accounts/google/accounts/');
  inflight.then(() => { inflight = null; }, () => { inflight = null; });
  return inflight;
}

export default getGoogleAccounts;
